module.exports = __webpack_public_path__ + "static/media/card-arrow-down.274343b5.png";